<template>
  <div class="card">
    <div class="table-responsive">
      <table
        class="table table-sm table-bordered table-striped text-center"
        width="100%"
      >
        <thead class="bg-teal text-white">
          <tr>
            <th>Usuário</th>
            <th>Permissão</th>
            <th>Cadastrado Por</th>
            <th>Cadastrado em</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody v-if="usuariosPermissao.length > 0">
          <tr
            v-for="usuarioPermissao in usuariosPermissao"
            :key="usuarioPermissao.id"
          >
            <td>{{ usuarioPermissao.codUsuario }}</td>
            <td>{{ usuarioPermissao.nome }}</td>
            <td>{{ usuarioPermissao.usuarioCriacao }}</td>
            <td>{{ dateTimeSqlToDateTimeBR(usuarioPermissao.dataCriacao) }}</td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-outline-danger btn-icon"
                title="Excluir"
                @click="$emit('deleteUsuarioPermissao', usuarioPermissao.id)"
              >
                <i class="ph-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5" class="text-center">
              Nenhum usuário com permissão cadastrado
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { dateTimeSqlToDateTimeBR } from '@/utils/date'

export default {
  name: 'ListUsuariosPermissao',

  props: {
    usuariosPermissao: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dateTimeSqlToDateTimeBR,
    }
  },
}
</script>
